// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","FooterHeading":"Footer_FooterHeading__AbfYl","Separator":"Footer_Separator__1Oeys"};